import { validateAndSend } from "../index";
import {
    startChatSessionEndPoint,
    sendWefayoAIMessageEndPoint as sendChatMessageEndPoint,
    getChatHistoryEndPoint,
    getSessionEndPoint,
    endChatSessionEndPoint,
    createNewConversationEndPoint,
    switchConversationEndPoint,
    deactivateConversationEndPoint
} from "../endPoints";

import { startSessionRules } from "./startSessionRules";
import { sendMessageRules } from "./sendMessageRules";
import { createConversationRules } from "./createConversationRules";

export const startChatSession = async (agentType) => {
    return validateAndSend({
        endPoint: startChatSessionEndPoint,
        inputs: { agentType },
        rules: startSessionRules,
        formData: {
            agentType
        },
        emit: true
    });
}

export const sendChatMessage = async (inputs) => {
    const formData = {
        sessionId: inputs.sessionId,
        message: inputs.message
    };
    
    // Include conversationId if provided
    if (inputs.conversationId) {
        formData.conversationId = inputs.conversationId;
    }

    return validateAndSend({
        endPoint: sendChatMessageEndPoint,
        inputs: inputs,
        rules: sendMessageRules,
        formData: formData,
        emit: true
    });
}

export const getChatHistory = async () => {
    return validateAndSend({
        endPoint: getChatHistoryEndPoint(),
        emit: true
    });
}

export const getSession = async (sessionId) => {
    return validateAndSend({
        endPoint: getSessionEndPoint(sessionId),
        emit: true
    });
}

export const endChatSession = async (sessionId) => {
    return validateAndSend({
        endPoint: endChatSessionEndPoint(sessionId),
        emit: true
    });
}

export const createNewConversation = async (sessionId, title = 'New Conversation') => {
    return validateAndSend({
        endPoint: createNewConversationEndPoint(sessionId),
        inputs: { title },
        rules: createConversationRules,
        formData: { title },
        emit: true
    });
};

export const switchConversation = async (sessionId, conversationId) => {
    return validateAndSend({
        endPoint: switchConversationEndPoint(sessionId, conversationId),
        emit: true
    });
};

export const deactivateConversation = async (sessionId, conversationId) => {
    return validateAndSend({
        endPoint: deactivateConversationEndPoint(sessionId, conversationId),
        emit: true
    });
}; 